import React from "react";
import {
  Box,
  InputGroup,
  Input,
  InputLeftElement,
  IconButton,
  // InputRightElement,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { primary } from "../../utils/colors";
import useThemeColors from "../../hooks/useThemeColors";

const SearchInput = ({ placeholder, searchName, onChange, p, m }) => {
  const { newBorderMode, whiteMode, placeholderColor, textPrimary } =
    useThemeColors();

  // Set border color to blue if searchName has characters, otherwise use default border color
  const borderColor =
    searchName && searchName.length > 0 ? primary : newBorderMode;
  const borderColorHover =
    searchName && searchName.length > 0 ? primary : primary;

  return (
    <Box w="100%" m={m ? m : "0 0 1rem"} p={p ? p : "0 2rem"}>
      <InputGroup w={["100%", "100%", "100%"]}>
        <Input
          type="text"
          placeholder={placeholder}
          size="lg"
          bg={whiteMode}
          borderRadius="10rem"
          border={`1px solid ${borderColor}`} // Use dynamic border color
          color={textPrimary}
          value={searchName}
          onChange={onChange}
          height="3rem"
          fontSize={["1rem", "0.938rem"]}
          fontWeight="500"
          _placeholder={{ color: placeholderColor }}
          _focusVisible={{
            zIndex: "1",
            borderColor: borderColorHover,
            boxShadow: `none`,
          }}
        />
        <InputLeftElement h="100%" pl="1rem">
          <IconButton
            h="34px"
            w="34px"
            icon={<SearchIcon />}
            borderRadius="full"
            _hover={{ bgColor: "none" }}
            _focus={{ bgColor: "none" }}
            variant="ghost"
          />
        </InputLeftElement>
        {/* <InputRightElement right="0rem" top="4px" minW="200px">
          <Flex align="center" justify="flex-end" w="100%">
            <Button
              onClick={handleSearch}
              bg={backgroundLight}
              color={textSecondary}
              borderRadius="10rem"
              size="sm"
              fontSize="sm"
              px="3rem"
            >
              {t("button.search")}
            </Button>
          </Flex>
        </InputRightElement> */}
      </InputGroup>
    </Box>
  );
};

export default SearchInput;
